import type { ReactNode } from "react";
import { MdButtons } from "./MdButtons";

export function PageHeader({ title, md, lead, children }: {
  title: string;
  md?: { page: string; params?: Record<string, string | number | undefined> };
  /** Shown before the title (e.g. the song cover). */
  lead?: ReactNode;
  children?: ReactNode;
}) {
  return (
    <header className="page-header">
      {lead ? <div className="page-title">{lead}<h1>{title}</h1></div> : <h1>{title}</h1>}
      <div className="page-actions">
        {children}
        {md && <MdButtons page={md.page} params={md.params} />}
      </div>
    </header>
  );
}
